<template>
	<div class="location">
		<div class="amap" id="containerMap"></div>
		<div class="topBtn closeBtn" @click="closeAddress">关闭</div>
		<div class="topBtn affirmBtn" v-show="!hideBtn" @click="affirmAddress">确认</div>
		<div class="locationIcon" @click="getLocation">
			<van-icon name="aim" />
		</div>
		<div class="list">
			<div class="hearderSearch">
				<van-field type="text" @focus="hideBtn = true" @blur="hideBtn = false" v-model="pageQuery.address" @input="inputStatus" placeholder="请输入" class="input"/>
				<span class="searchBtn" @click="search">搜索</span>
			</div>
			<div id="pickerAuto" class="pickerAuto"></div>
			<div class="pois">
				<div class="poi_li" v-for="(item, index) in poiList" :key='index' @click="handPoi(item, index)">
					<div class="poiInfo">
						<img src="@/assets/rescueImgs/e_icon.png" alt="">
						<div class="info">
							<div :class="['title', activePOIIndex == index ? 'activePOI' : '']">{{ item.name }}</div>
							<div v-if="item.address" :class="['address', activePOIIndex == index ? 'activePOI' : '']">
								{{ item.pname ? item.pname : pageQuery.province }}{{ item.cityname ? item.cityname : pageQuery.city }}{{ item.adname ? item.adname : pageQuery.district }}{{ item.address }}
							</div>
						</div>
					</div>
					<div class="status">
						<!-- <img v-if='activePOIIndex == index' src="@/assets/rescueImgs/poiIcon.png" alt=""> -->
						<van-icon v-if='activePOIIndex == index' name="certificate" size="20" :color="$themeColor" />
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { saveLocation } from '@/apis/checkList';
import { getGeoLocation } from '@/utils/index';
export default {
	name: 'CheckLocation',
	props: {
		checkAddressInfo: {
			type: Object | String,
			default: ''
		}
	},
	data(){
		return {
			zoom: 15,
			pageQuery: {
				address: "",
				lat: 0,
				lng: 0,
				type: 1,
				province: '',			//省
				city: '全国',			//市
				district: '',			//区
			},
			locationMap: null,
			marker_startIcon: require('@/assets/rescueImgs/marker_start.png'),
			placeSearch: null,
			poiList: [],
			activePOIIndex: 0,
			marker: [],
			positionPicker: null,
			handPOIStatus: true,
			inputChange: false,
			order: '',				//客户h5修改地址
			hideBtn: false,
			locInfo: '',
			btnLoading: false
		}
	},
	created(){
		// let query = this.$route.query;
		// console.log(query, 'query')
		// if(query.address){
		// 	this.locInfo = query
		// }
		// this.order = query.order ? query.order : '';
		// this.pageQuery.address = query.address;
		// this.pageQuery.city = query.city;
		// this.pageQuery.type = query.type;
		// this.pageQuery.lng = query.lng != 0 ? Number(query.lng) : 114.131764;
		// this.pageQuery.lat = query.lat != 0 ? Number(query.lat) : 22.548171;
		// this.handPOIStatus = query.address ? true : false;
	},
	mounted(){
		if(this.checkAddressInfo){
			let query = this.checkAddressInfo
			this.locInfo = query
			this.order = query.order ? query.order : '';
			this.pageQuery.address = query.address;
			this.pageQuery.city = query.city;
			this.pageQuery.type = query.type;
			this.pageQuery.lng = query.lng != 0 ? Number(query.lng) : 114.131764;
			this.pageQuery.lat = query.lat != 0 ? Number(query.lat) : 22.548171;
			this.handPOIStatus = query.address ? true : false;
		}
		// 确保地图容器存在后再初始化
		this.$nextTick(() => {
			this.initLocMap();
		});
	},
	beforeDestroy() {
		try {
			if (this.positionPicker) {
				this.positionPicker.off(); // 移除所有事件监听器
				this.positionPicker.stop();
				this.positionPicker = null;
			}
			if (this.locationMap) {
				this.locationMap.clearMap(); // 清除地图上的所有覆盖物
				this.locationMap.destroy();
				this.locationMap = null;
			}
		} catch (e) {}
	},
	methods: {
		inputStatus(){
			this.inputChange = true
		},
		// 当前定位
        getLocation(){
            this.$toast.loading({
				message: '定位中...',
				forbidClick: true, 
				duration: 0
			})
            getGeoLocation().then((res)=>{
				this.pageQuery.address = res.address;
				this.pageQuery.province = res.province;
				this.pageQuery.city = res.city;
				this.pageQuery.district = res.district;
				this.pageQuery.lng = res.lng;
				this.pageQuery.lat = res.lat;
				this.POISearch();
				this.$toast.clear();
            }).catch((err)=>{
                this.$toast.clear();
                this.$toast(err);
            })
        },
		initLocMap(){
		let that = this;
		this.$toast.loading({
			message: '加载中...',
			forbidClick: true, 
			duration: 0
		})
		// 确保容器存在
		const container = document.getElementById('containerMap');
		if (!container) {
			this.$toast.clear();
			this.$toast('地图容器不存在');
			return;
		}
		
		// 检查AMap和AMapUI是否加载
		if (!window.AMap || !window.AMapUI) {
			this.$toast.clear();
			this.$toast('地图资源加载失败');
			return;
		}
		
		AMapUI.loadUI(["misc/PositionPicker"], function(PositionPicker) {
			try {
				that.locationMap = new AMap.Map(`containerMap`, {
					zoom: that.zoom,
					center: [that.pageQuery.lng, that.pageQuery.lat],
					resizeEnable: true,
					disableHash: true
				})
				AMap.plugin('AMap.PlaceSearch', function () {
					that.placeSearch = new AMap.PlaceSearch({
						city: that.pageQuery.city,
						pageSize: 20,
						extensions: 'all'
					});
				})
				that.positionPicker = new PositionPicker({
					mode: "dragMap",
					map: that.locationMap,
					iconStyle: {
						url: that.marker_startIcon,
						size: [26, 38],
						ancher: [13, 38],
					}
				})
				
				if(that.handPOIStatus){
					that.POISearch();
				}
				that.positionPicker.on("success", function(positionResult) {
					if(!that.handPOIStatus){
						let addressInfo = [{
							address: positionResult.nearestPOI,
							location: positionResult.position,
							name: positionResult.address,
						}]
						let pois = addressInfo.concat(positionResult.regeocode.pois);
						that.poiList = pois;
						that.activePOIIndex = 0;
						that.pageQuery.province = positionResult.regeocode.addressComponent.province;
						that.pageQuery.city = positionResult.regeocode.addressComponent.city;
						that.pageQuery.district = positionResult.regeocode.addressComponent.district;
						that.pageQuery.address =  pois.length != 0 ? pois[0].name : positionResult.address;
						that.pageQuery.lng = pois.length != 0 ? pois[0].location.lng : positionResult.position.lng;
						that.pageQuery.lat = pois.length != 0 ? pois[0].location.lat : positionResult.position.lat;
					}
					that.handPOIStatus = false;
				})
				that.positionPicker.start();
			} catch (error) {
				console.error('地图初始化失败:', error);
			}
			that.$toast.clear()
		}, function(error) {
			// 加载UI组件失败
			console.error('加载地图UI组件失败:', error);
			that.$toast.clear();
			that.$toast('地图组件加载失败');
		})
	},
		// 点击搜索
		search(){
			this.handPOIStatus = true
			this.POISearch();
		},
		POISearch(){
		let that = this;
		let keyWord = that.pageQuery.address;
		let lcaArr = ''
		if(this.locInfo){
			lcaArr = [{
				address: '',
				location: {
					lng: this.locInfo.lng,
					lat: this.locInfo.lat
				},
				name: this.locInfo.address,
			}]
			this.locInfo = ''
		}
		// 检查placeSearch是否存在
		if (!that.placeSearch) {
			that.$toast('搜索服务未初始化');
			return;
		}
		try {
			that.placeSearch.search(keyWord, function(status, result) {
				// 查询成功时，result即为对应的POI详情
				console.log(status, result, keyWord, '关键字')
				if(status == 'complete'){
					let poiList = result.poiList.pois;
					that.poiList = lcaArr ? lcaArr.concat(poiList) : poiList;
					if (that.poiList.length > 0) {
						that.handPoi(that.poiList[0], 0)
						// that.map.setCenter([poiList[0].location.lng, poiList[0].location.lat]);
					} else {
						that.$toast('未找到相关地点');
					}
				}else{
					that.$toast('搜索失败，请稍后重试');
					// 避免递归调用导致的问题
					// that.getLocation()
				}
			}) 
		} catch (error) {
			console.error('搜索失败:', error);
			that.$toast('搜索失败，请稍后重试');
		}
	},
		// 点击poi
		handPoi(e, index){
			let that = this;
			that.handPOIStatus = true;
			that.activePOIIndex = index;
			that.pageQuery.province = e.pname ? e.pname : that.pageQuery.province;
			that.pageQuery.city = e.cityname ? e.cityname : that.pageQuery.city;
			that.pageQuery.district = e.adname ? e.adname : that.pageQuery.district;
			that.pageQuery.address = e.name;
			that.pageQuery.lng = e.location.lng;
			that.pageQuery.lat = e.location.lat;
			that.locationMap.setCenter([e.location.lng, e.location.lat]);
		},
		// 关闭窗口
		closeAddress(){
			this.$emit('close')
		},
		// 确认地址
		affirmAddress(){
			if(this.btnLoading){
				return
			}
			this.btnLoading = true
			setTimeout(()=>{
				this.btnLoading = false
			}, 1000)
			if(this.order){
				let data;
				if(this.pageQuery.type == 1){
					// 救援地
					data = {
						order: this.order,
						theodolitic: this.pageQuery.lng + ',' + this.pageQuery.lat,
						a_province: this.pageQuery.province,
						a_city: this.pageQuery.city,
						a_area: this.pageQuery.district,
						address: this.pageQuery.province + this.pageQuery.city + this.pageQuery.district + this.pageQuery.address
					};
					
				}else{
					// 目的地
					data = {
						order: this.order,
						transit: this.pageQuery.lng + ',' + this.pageQuery.lat,
						d_province: this.pageQuery.province,
						d_city: this.pageQuery.city,
						d_area: this.pageQuery.district,
						destination: this.pageQuery.province + this.pageQuery.city + this.pageQuery.district + this.pageQuery.address
					};
				}
				saveLocation(data).then((res)=>{
					if(res.data.code == 1){
						this.$toast('修改成功！');
						this.$emit('setLocation')
					}else{
						this.$toast(res.data.info);
					}
				})
			}else{
				this.$emit('setLocation', this.pageQuery)
			}
		}
	}
}
</script>

<style lang='scss' scoped>
	.pickerAuto{
		position: fixed;
		top: 10000px;
	}
	.location{
		width: 100%;
		height: 100vh;
		display: flex;
		flex-direction: column;
		.topBtn{
			position: fixed;
			top: 24px;
			width: 56px;
			height: 28px;
			font-size: 14px;
			text-align: center;
			line-height: 28px;
			background: var(--theme-color);
			color: var(--theme-btn);
			border-radius: 4px;
		}
		.affirmBtn{
			right: 15px;
		}
		.closeBtn{
			left: 15px;
			background: var(--theme-btn);
			color: var(--theme-color);
		}
		.locationIcon{
			width: 40px;
			height: 40px;
			border-radius: 10px;
			background: #fff;
			position: fixed;
			top: 180px;
			right: 15px;
			font-size: 20px;
			display: flex;
			justify-content: center;
			align-items: center;
		}
		.amap{
			height: 378px;
		}
		.list{
			flex: 1;
			border-radius: 10px 10px 0px 0px;
			.hearderSearch{
				display: flex;
				align-items: center;
				justify-content: space-between;
				padding: 15px;
				box-sizing: border-box;
				.searchBtn{
					width: 32px;
					height: 19px;
					font-size: 14px;
					font-family: PingFangSC-Medium;
					line-height: 19px;
					color: var(--theme-text-color);
				}
				.input{
					flex: 1;
					margin-right: 10px;
					// width: 306px;
					height: 38px;
					background: #FCFCFC;
					border-radius: 4px;
					padding: 0 10px;
					box-sizing: border-box;
					border: 0;
					line-height: 38px;
				}
			}
			.pois{
				height: 350px;
				overflow-y: scroll;
				.poi_li{
					padding: 15px 15px 17px 15px;
					box-sizing: border-box;
					display: flex;
					justify-content: space-between;
					align-items: center;
					height: 74px;
					border-bottom: 1px solid #E2E2E2;
					.status{
						img{
							width: 19px;
							height: 13px;
						}
					}
					.poiInfo{
						display: flex;
						align-items: center;
						height: 100%;
						img{
							width: 12px;
							height: 15px;
							margin-right: 11px;
						}
						.info{
							height: 100%;
							display: flex;
							flex-direction: column;
							justify-content: space-between;
							.title{
								font-size: 14px;
								font-family: PingFang SC;
								font-weight: bold;
								line-height: 20px;
								color: #1F2129;
							}
							.address{
								font-size: 11px;
								font-family: PingFang SC;
								font-weight: 400;
								line-height: 16px;
								color: #999999;
							}
							.activePOI{
								color: var(--theme-text-color);
								z-index: 99;
							}
						}
					}
				}
			}
		}
	}
</style>
